import {
    CollisionEventType,
    Component,
    Object3D,
    PhysXComponent,
} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {Bullet} from './bullet.js';
import {AudioSource} from '@wonderlandengine/spatial-audio';
import {ParticleSystem} from './particle-system.js';
import {PaintballClient} from './paintball-client.js';
import {CursorTarget} from '@wonderlandengine/components';
import {TargetShootingPanel} from './targetShootingPanel.js';

/**
 * shootingTarget.js
 */
export class ShootingTarget extends Component {
    static TypeName = 'shooting-target';

    @property.object()
    hitsound!: Object3D;

    @property.object()
    spawnLocation!: Object3D;

    @property.object()
    player!: Object3D;

    shootCounter = 0;
    targetHitCounter = 0;

    targetShootingInProgress = false;

    start() {
        const targetPhysx = this.object.children[0].getComponent(PhysXComponent);

        targetPhysx?.onCollision((type, CollidingPhysxComp) => {
            if (type != CollisionEventType.TriggerTouch) return;
            const bullet = CollidingPhysxComp.object.getComponent(Bullet);
            if (!bullet) return;
            setTimeout(this.triggerTargetShoot.bind(this), 0);
        });
    }

    triggerTargetShoot() {
        TargetShootingPanel.targetShots += 1;
        this.hitsound.getComponent(AudioSource)?.play();
        this.explode();

        setTimeout(() => {
            if (!this.targetShootingInProgress) this.spawn();
        }, 5000);
    }
    spawn() {
        this.setActiveHeigherarchy(this.object, true);
    }

    explode() {
        //add explode particle effects
        this.spawnLocation
            ?.getComponent(ParticleSystem)
            ?.spawnParticles(this.object.getPositionWorld());
        this.setActiveHeigherarchy(this.object, false);
    }

    setActiveHeigherarchy(obj: Object3D, active: boolean) {
        const comps = obj.getComponents();
        comps.forEach((comp) => {
            comp.active = active;
        });
        const children = obj.children;
        if (children.length > 0) {
            children.forEach((child) => this.setActiveHeigherarchy(child, active));
        }
    }
}
